import React from 'react';
import ReactPhoneInput from 'react-phone-input-2';
import type { CountryData } from 'react-phone-input-2';

import clsx from 'clsx';

import { FormField } from 'components/_basic/Form/FormField';

import { IPhoneInputProps } from './types';

import styles from './PhoneInput.module.scss';

import 'react-phone-input-2/lib/material.css';

const PhoneInputContainer: React.FC<IPhoneInputProps> = ({ id, error, disabled, name, ...rest }) => {
  const onChange = (
    value: string,
    data: CountryData | object,
    event: React.ChangeEvent<HTMLInputElement>,
    formattedValue: string,
  ) => {
    rest.onChange?.(value, data, event, formattedValue);
  };
  return (
    <ReactPhoneInput
      inputProps={{ id, name }}
      {...rest}
      country={'us'}
      containerClass={clsx({ [styles.error]: !!error, [styles.disabled]: disabled })}
      specialLabel=""
      disabled={disabled}
      onChange={onChange}
    />
  );
};

export const PhoneInput: React.FC<IPhoneInputProps> = (props) => {
  const { id, label, fieldError, disabled, ...rest } = props;

  return (
    <FormField id={id} label={label} error={fieldError?.message} disabled={disabled} containerClass={styles.container}>
      <PhoneInputContainer disabled={disabled} {...props} country={'us'} specialLabel="" {...rest} />
    </FormField>
  );
};
